<template>
  <va-card :title="$t('menu.loads_finished')">
    <div class="row">
      <div class="flex xs12 sm2">
        <va-date-picker
          :label="$t('tables.date')"
          v-model="delivery_date"
        />
      </div>

      <div class="flex" style="margin-left: -20px">
        <va-button
          small
          color="secondary"
          icon="fa fa-eraser"
          class="ma-2"
          @click="clear(delivery_date)"
        >
          {{ $t('menu.clear') }}
        </va-button>
      </div>

      <div class="flex xs3">
        <va-select
          v-model="loadType"
          :options='loadTypes'
          label="Tipo de Carga"
          textBy="name"
          keyBy="id"
          clearable="false"
          placeholder="Selecione o tipo de carga"
        />
      </div>

      <div class="flex xs2">
        <va-input
          v-model="searchName"
          :label="$t('menu.search')"
          removable
        >
        </va-input>
      </div>

      <div class="flex xs12 md2">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page, searchName)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>

      <div class="flex xs2">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>
    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      v-show="!loading"
      api-mode
      no-pagination
      @page-selected="readItems"
    >
      <template slot="start_of_operation" slot-scope="item">
        {{ item.rowData.start_of_operation | prettyDate }}
      </template>

      <template slot="end_of_operation" slot-scope="item">
        {{ item.rowData.end_of_operation | prettyDate }}
      </template>

      <template slot="actions" slot-scope="props">
        <va-button v-if="props.rowData.divergence_load_products.length > 0"
          small
          inline
          color="danger"
          icon="fa fa-list-alt"
          class="ma-1"
          :to="{ name: 'data-table-load-divergences', params: { loadID: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 10, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
        >
          {{ $t('menu.divergence') }}
        </va-button>
        <va-button v-if="props.rowData.loads_checked == true "
            small
            inline
            color="#118ab2"
            icon="fa fa-list-alt"
            class="ma-1"
            :to="{ name: 'load_checks', params: { loadId: props.rowData.id, loadCode: props.rowData.code, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
          >
            {{ 'Checkout' }}
        </va-button>
        <va-button v-if="props.rowData.load_histories_count > 0"
            small
            inline
            color="green"
            icon="fa fa-list-alt"
            class="ma-1"
            :to="{ name: 'load-history', params: { loadId: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 10 ,delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
          >
            {{ $t('menu.order_history') }}
        </va-button>
        <va-button
          small
          inline
          color="dark"
          icon="fa fa-list-alt"
          class="ma-0"
          :to="{ name: 'lists-load-table', params: { loadID: props.rowData.id, loadCode: props.rowData.code, assemblyLine: 12, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
        >
          {{ $t('menu.lists') }}
        </va-button>
        <va-button
          small
          inline
          color="greenLight"
          icon="fa fa-list-alt"
          class="ma-1"
          :to="{ name: 'data-table-load-products', params: { loadID: props.rowData.id, loadCode: props.rowData.code,assemblyLine: 10, delivery_date: delivery_date, current_page: current_page, search: search, perPage: perPage } }"
        >
          {{ $t('menu.products') }}
        </va-button>
        <va-button
          small
          outline
          color="secondary"
          icon="fa fa-times"
          class="ma-0"
          @click="showConfirmResetSequence = true, codeLoadSequence = props.rowData.id"
          v-if="props.rowData.status_id === 18"
        >
          {{ $t('menu.reset_sequence') }}
        </va-button>
      </template>
    </va-data-table>

      <Pagination
        :currentPage="current_page"
        :totalPages="totalPages"
        :onChange="onPageChange"
        v-show="!loading"
      />
      <va-modal
        v-model="showConfirmResetSequence"
        size="small"
        :title="$t('modal.confirm')"
        :message="$t('modal.messageConfirmSequenceLoadSequence')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >

      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmResetSequence = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="resetSequence(codeLoadSequence), showConfirmResetSequence = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

  </va-card>
</template>

<script>
import LoadSequenceAPI from '@/services/LoadSequenceAPI'
import LoadAPI from '@/services/LoadAPI'
import moment from 'moment'
import * as spinners from 'epic-spinners'
import { showError } from '@/global'
import { mapState } from 'vuex'
import { Ability } from '@casl/ability'
import LoadTypeAPI from '@/services/LoadTypeAPI'
import Pagination from '../../shared/Pagination'
export const ability = new Ability()

export default {
  name: 'modals',
  components: {
    ...spinners,
    Pagination,
  },
  data () {
    return {
      ability: [],
      data: [],
      loading: false,
      delivery_date: '',
      showModal: false,
      showConfirmResetSequence: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      perPage: '10',
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      searchName: '',
      current_page: '',
      loadTypes: [],
      loadType: {
        id: '',
        name: '',
      },
    }
  },

  channels: {
    NeedRefreshLoads: {
      received (data) {
        this.readItems()
      },
    },
  },

  beforeMount () {
    this.ability = ability.update(this.rules)
    if (this.$route.params.delivery_date !== undefined) {
      this.delivery_date = `${this.$route.params.delivery_date}`
    } else {
      this.readDeliveryDate(this.currentLocality.id)
    }
  },

  filters: {
    prettyDate (value) {
      if (value !== undefined) {
        return moment.parseZone(value).format('DD/MM/YYYY HH:mm')
      } else {
        return value
      }
    },
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshLoads', company: this.currentUser.company })
    this.search = (this.$route.params.search !== undefined) ? `${this.$route.params.search}` : ''
    this.getDefaultLoadType()
  },

  computed: {
    ...mapState(['rules', 'currentLocality', 'currentUser']),

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.loads.id'),
      },
      {
        name: 'locality',
        title: this.$t('tables.loads.locality_name'),
      },
      {
        name: 'trip_number',
        title: this.$t('tables.loads.trip_number'),
      },
      {
        name: 'code',
        title: this.$t('tables.loads.code'),
      },
      {
        name: 'vehicle',
        title: this.$t('tables.loads.vehicle'),
      },
      {
        name: 'weight',
        title: this.$t('tables.loads.weight'),
      },
      {
        name: 'quantity_orders',
        title: this.$t('tables.loads.quantity_orders'),
      },
      {
        name: 'quantity_boxes',
        title: this.$t('tables.loads.quantity_boxes'),
      },
      {
        name: 'status',
        title: this.$t('tables.loads.status'),
      },
      {
        name: 'delivery_date',
        title: this.$t('tables.loads.delivery_date'),
      },
      {
        name: '__slot:start_of_operation',
        title: this.$t('tables.operation.start_of_operation'),
      },
      {
        name: '__slot:end_of_operation',
        title: this.$t('tables.operation.end_of_operation'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      return spinners.ScalingSquaresSpinner
    },
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.current_page)
    },
    searchName: function (newVal) {
      if (!newVal) {
        this.readItems(this.current_page)
      }
    },
    delivery_date: function (newVal) {
      this.readItems(this.current_page)
    },

    '$store.state.currentLocality': function () {
      this.readItems(this.current_page)
    },

    loadType: function (newVal) {
      this.readItems(this.current_page)
    },
  },
  methods: {
    onPageChange (page) {
      this.readItems(page)
    },
    clear (field) {
      this.delivery_date = ''
    },
    async readItems (page, searchName) {
      this.loading = true

      await LoadTypeAPI.getAllLoadTypes().then(response => {
        this.loadTypes = response.data.load_types
      }).catch(e => {
        showError(e)
      })

      const params = {
        locality: this.currentLocality.id,
        page: page,
        quantity: this.perPage,
        search: this.searchName,
        delivery_date: this.delivery_date,
        load_type_id: this.loadType.id,
      }

      this.current_page = this.$route.params.current_page

      await LoadAPI.getFilteredLoadsFinished(params).then(response => {
        this.data = response.data.loads
        this.totalPages = response.data.total_pages
        this.current_page = response.data.current_page
        this.loading = false
      }).catch(e => {
        this.loading = false
        showError(e)
      })
    },

    async readDeliveryDate (localityId) {
      await LoadAPI.getLastDeliveryDate(localityId).then(response => {
        this.delivery_date = response.data.last_delivery_date
      }).catch(e => {
        showError(e)
      })
    },

    async getDefaultLoadType () {
      await LoadTypeAPI.getDefaultLoadType().then(response => {
        this.loadType = response.data.load_type
      }).catch(e => {
        showError(e)
      })
    },

    async resetSequence (loadID) {
      this.loading = true
      await LoadSequenceAPI.resetSequence(loadID).then(response => {
        this.showToast(`Sequência resetada com sucesso!`, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.loading = false
        this.forceRerender()
        this.readItems()
      }).catch(e => {
        this.loading = false
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },
  },
}
</script>
